"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parsedJsonOrOrig = exports.parsedJsonOrNothing = exports.safeStringify = void 0;
const fast_safe_stringify_1 = __importDefault(require("fast-safe-stringify"));
exports.safeStringify = fast_safe_stringify_1.default;
function parsedJsonOrNothing(str) {
    return _parseJson(str, false);
}
exports.parsedJsonOrNothing = parsedJsonOrNothing;
function parsedJsonOrOrig(str) {
    return _parseJson(str, true);
}
exports.parsedJsonOrOrig = parsedJsonOrOrig;
function _parseJson(str, returnOriginalOnFail) {
    if (!str) {
        return returnOriginalOnFail ? str : undefined;
    }
    try {
        return JSON.parse(str);
    }
    catch (err) {
        if (returnOriginalOnFail) {
            return str;
        }
        else {
            return undefined;
        }
    }
}
//# sourceMappingURL=json-util.js.map